// extracted by mini-css-extract-plugin
export default {"container":"content_container__amLhv","header":"content_header__a3jIt","body":"content_body__DoXft","footer":"content_footer__n4tKV"};